// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import LocationInput from '../location';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.LOCATION,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.US_LOCATION_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   additional_attributes: {
    //     location_type: 'property_location',
    //   },
    // },
  },
};
const LocationInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  className,
  fullWidth,
}) => {
  return (
    <LocationInput
      label={label}
      analytics={analyticsPayload}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default LocationInputWithAnalytics;
